import ShimmerBody from "./ShimmerBody";

const ShimmerUI = () => {
  return (
    <>
      <ShimmerBody />
    </>
  );
};

export default ShimmerUI;
